import React from 'react';

type StepWrapperProps = {
  heading: string | React.ReactNode;
  children: React.ReactNode;
  // eslint-disable-next-line react/require-default-props
  headingRightContent?: React.ReactNode;
};

const StepWrapper = ({
  heading,
  children,
  headingRightContent,
}: StepWrapperProps) => (
  <div className="ai-sequence-step-wrapper">
    <div className="ai-sequence-step-wrapper__header">
      <span className="ai-sequence-step-wrapper__title">{heading}</span>

      {headingRightContent && (
        <div className="ai-sequence-step-wrapper__text">
          {headingRightContent}
        </div>
      )}
    </div>
    <div className="ai-sequence-step-wrapper__content">{children}</div>
  </div>
);

export default StepWrapper;
